import React from "react";

export default function PhotoGallery() {

  return (
    <h1>Gallery coming soon</h1>
  )
    
}